<vy-layout-page [imageLayout]="getImageLayout()">
  <ng-container header>
    <app-banner-alert [alerts]="state().globalAlerts"></app-banner-alert>
    <app-header [language]="state().language" [userInfo]="state().user" [isTransparent]="false"></app-header>
  </ng-container>
  <ng-container main> <router-outlet></router-outlet> </ng-container>
  <ng-container footer>
    <app-footer
      [language]="state().language ?? 'es'"
      [userType]="state().user?.userType?.toLocaleLowerCase() ?? 'default'"
    ></app-footer>
  </ng-container>
</vy-layout-page>
